import {TabState, TabStateDefaults} from 'Navigation';

export default class EntityTestOrdersTabState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Test Orders',
      closeable: false,
      preferenceKey: 'entity-test-orders-tab',
    };
  }
}
